import axios from 'axios';
import { getAuthHeader } from './authService';
import API_CONFIG from '../config';

const API_URL = API_CONFIG.BASE_URL;

const getHeaders = () => ({
  ...getAuthHeader(),
  'Content-Type': 'application/json',
  'Accept': 'application/json'
});

export const supplierService = {
  getAllSuppliers: async () => {
    try {
      const response = await axios.get(`${API_URL}/suppliers`, {
        headers: getHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching suppliers:', error.response || error);
      throw error;
    }
  },

  createSupplier: async (supplierData) => {
    try {
      console.log('Creating supplier with data:', supplierData);
      const response = await axios.post(`${API_URL}/suppliers`, supplierData, {
        headers: getHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error creating supplier:', error.response || error);
      throw error;
    }
  },

  updateSupplier: async (id, supplierData) => {
    try {
      console.log('Updating supplier with data:', supplierData);
      const response = await axios.put(`${API_URL}/suppliers/${id}`, supplierData, {
        headers: getHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error updating supplier:', error.response || error);
      throw error;
    }
  },

  deleteSupplier: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}/suppliers/${id}`, {
        headers: getHeaders()
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting supplier:', error.response || error);
      throw error;
    }
  }
}; 